// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProtocolViewer_Container__MuPep","PanelResizeHandle":"ProtocolViewer_PanelResizeHandle__OQd7P"};